module.exports = __webpack_public_path__ + "img/logo-the-lobby-nesplein.4dc758ddf995197edb4ef09dc7c7ad34.svg";